import GraphqlBuilder from 'utils/request/graphql/builder'
import FetchCachedFavourites from 'utils/fetch/cached/FetchCachedFavourites'
import MutationDeleteEmployeeToEmployeeFavourite from 'graphql/mutations/MutationDeleteEmployeeToEmployeeFavourite'
import MutationEmployeeToEmployeeFavourite from 'graphql/mutations/MutationEmployeeToEmployeeFavourite'
import store from "services/redux/store";
import _ from 'lodash';
import FetchCachedOtherEmployeeBookings from 'utils/fetch/cached/FetchCachedOtherEmployeeBookings'
import HelperEmployeePrivacy from 'utils/HelperEmployeePrivacy'
import selectFavourites from 'services/redux/data/selectors/selectFavourites'

const HelperEmployeeFavourite = {
	
	canFavourite: ( employee ) => {
		return HelperEmployeePrivacy.canFavourite( employee, HelperEmployeeFavourite.isFavourite( employee.guid )  )
	},
	
	isFavourite: ( employee_guid ) => {
		return _.get( selectFavourites( store.getState() ), [ employee_guid, 'is_favourite' ] , 'no' ) !== 'no';
	},
	
	setFavourite: ( employee_guid, favourite, onStart, onComplete, onError ) => {
		const graphQl = new GraphqlBuilder();
		
		graphQl
			.setOnStart( onStart )
			.setOnSuccess( () => {
				FetchCachedFavourites.reload( { callbackSuccess: () => {
					
					FetchCachedOtherEmployeeBookings.reset();
					
					if( _.isFunction( onComplete ) ) {
						onComplete();
					}
				}});
			})
			.setOnError( onError );
		
		// Remove from favourites if currently a favourite
		if( !favourite ) {
			graphQl.addQuery( 'delete_employee_to_employee_favourite', MutationDeleteEmployeeToEmployeeFavourite, {
				employee_guid: '::employee_guid',
				favourite_employee_guid: employee_guid
			});
			
		}else{
			graphQl.addQuery( 'create_employee_to_employee_favourite', MutationEmployeeToEmployeeFavourite, {
				employee_guid: '::employee_guid',
				favourite_employee_guid: employee_guid
			});
		}
		graphQl.execute();
	}
}

export default HelperEmployeeFavourite
